export default "__VITE_ASSET__a95n6Cxu__"